import { Button, ButtonProps, forwardRef } from "@chakra-ui/react";
import { theme } from "@ovou-inc/ovou-ui";

// The two footer-button recipes shared by the profile-templates modals
// (Figma "Btn ovou"): a full-height orange primary and an outline cancel.
// Built with Chakra's forwardRef so they stay polymorphic — `as="a"` + href
// (CapReachedModal's Talk-to-sales CTA) and refs keep working — and forward
// every ButtonProps, so callers only add behaviour, never restyle.
//
// Radius follows Figma: 10px when a button stands alone, 8px when two sit
// side by side — pass `borderRadius="8px"` in paired footers.

const baseStyle: ButtonProps = {
  h: "56px",
  borderRadius: "10px",
  fontFamily: "Inter",
  fontWeight: 800,
  fontSize: "14px",
  lineHeight: 1,
  textTransform: "none",
};

export const ModalPrimaryButton = forwardRef<ButtonProps, "button">(
  (props, ref) => (
    <Button
      ref={ref}
      {...baseStyle}
      bg={theme.palette.brand.primary.orange}
      color={theme.palette.brand.primary.white}
      _hover={{ opacity: 0.9, textDecoration: "none" }}
      {...props}
    />
  ),
);
ModalPrimaryButton.displayName = "ModalPrimaryButton";

export const ModalCancelButton = forwardRef<ButtonProps, "button">(
  (props, ref) => (
    <Button
      ref={ref}
      {...baseStyle}
      border="1px solid"
      borderColor={theme.palette.ui.greys.grey3}
      color={theme.palette.brand.primary.black}
      bg={theme.palette.brand.primary.white}
      _hover={{
        bg: theme.palette.ui.greys.grey5,
        color: theme.palette.brand.primary.black,
      }}
      _focus={{
        bg: theme.palette.brand.primary.white,
        color: theme.palette.brand.primary.black,
      }}
      _active={{
        bg: theme.palette.ui.greys.grey5,
        color: theme.palette.brand.primary.black,
      }}
      {...props}
    />
  ),
);
ModalCancelButton.displayName = "ModalCancelButton";
